<template>
  <section class="space-y-5">
    <header>
      <h2 class="text-lg font-semibold text-gray-900">Gallery (About section photos)</h2>
      <p class="text-sm text-gray-500">
        Photos shown in the "About" section of campaign pages that haven't uploaded their
        own media. Drag to reorder — the first four appear in the mosaic and the rest open
        in the lightbox. Leave the gallery empty to let the About story text span the full
        width.
      </p>
    </header>

    <TemplateRepeatableList
      v-model="galleryProxy"
      :max-items="12"
      :new-item="newImage"
      item-noun="image"
    >
      <template #item="{ item }">
        <div class="space-y-2">
          <TemplateImageInput
            v-model="item.src"
            :upload-url="uploadUrl"
            subfolder="gallery"
            label="Image"
          />
          <input
            v-model="item.alt"
            type="text"
            maxlength="250"
            placeholder="Caption / alt text"
            class="w-full rounded-md border-gray-300 text-sm focus:border-pink-500 focus:ring-pink-500"
          >
        </div>
      </template>
    </TemplateRepeatableList>
  </section>
</template>

<script>
import TemplateRepeatableList from '../TemplateRepeatableList.vue';
import TemplateImageInput from '../TemplateImageInput.vue';

export default {
  name: 'GallerySectionEditor',
  components: { TemplateRepeatableList, TemplateImageInput },
  props: {
    gallery: { type: Array, required: true },
    uploadUrl: { type: String, required: true },
  },
  emits: ['update:gallery'],
  computed: {
    galleryProxy: {
      get() { return this.gallery; },
      set(value) { this.$emit('update:gallery', value); },
    },
  },
  methods: {
    newImage() {
      return { src: '', alt: '' };
    },
  },
};
</script>
